// @ts-nocheck
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { isMobile } from '../../utils/utils';
import snsEnv from '../../env/env-sns';

export default function (options = {}) {
  const { headers = {} } = options;
  const snsAxiosClient = axios.create({
    headers: { ...headers },
  });

  // Request interceptor
  snsAxiosClient.interceptors.request.use(
    function (config) {
      config.headers['x-swy-correlation-id'] = uuidv4();
      config.headers['x-swy-date'] = new Date();
      if (config.headers.data) {
        config.data = { ...config.headers.data };
        const { data, ...rest } = config.headers;
        config.headers = { ...rest };
      } else {
        config.headers = { ...config.headers };
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    },
  );
  snsAxiosClient.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      const banner = document.getElementById('banner').dataset.banner;
      const env = document.getElementById('env').dataset.env;
      const appData = snsEnv(banner, env, 'web');

      if (error.response.data.errors && error.response.data.errors[0].code === 'OSAR_SNS_0010') {
        // Reload the page for session expiry to redirect to re-sign page
        if (!isMobile()) {
          window.location.assign(appData.RE_SIGN_IN_URL);
        }
      } else if (error.response.data.errorCode === 'PERC0001') {
        //This condition is only for P13 api unauthorized error. Need to check with P13 team to verify the error code
        if (!isMobile()) {
          window.location.assign(appData.RE_SIGN_IN_URL);
        }
      } else {
        return Promise.reject(error);
      }
    },
  );

  return snsAxiosClient;
}
